import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { TextInput } from '~/eds/src/components/TextInput/TextInput';

interface SearchAndFiltersProps {
  search: string;
  onSearch: (updatedValue: string) => void;
}

export const SearchAndFilters = ({
  search,
  onSearch,
}: SearchAndFiltersProps) => {
  const intl = useIntl();

  return (
    <Layout>
      <TextInput
        name="search question input"
        placeholder={intl.formatMessage({
          id: 'SearchAndFilters.questions.searchPlaceholder',
          defaultMessage: 'Search',
          description: 'Placeholder text for search input',
        })}
        value={search}
        onChange={(value) => onSearch(value || '')}
      />
    </Layout>
  );
};
